import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

const UserProfile = () => {
  return (
    <Container maxWidth="sm" sx={{ height: "100%" }}>
      <Box>User profile</Box>
    </Container>
  );
};

export default UserProfile;
